module.exports = __webpack_public_path__ + "f05a003288bedba5b2621caefc8651bc.png";